import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { browserHistory } from 'react-router';
import { handleUserLogout } from '../../pages/Accounts/createAccount/actions';
import commonUtil from '../../utils/commonUtil';
import NewFooterComponentWap from '../NewFooter/FooterWap';

const channel = commonUtil.getChannel();
const applicationRoutes = commonUtil.getApplicationRoutes();

class Footer extends React.Component {
  componentDidUpdate = () => {
    if (document.querySelector('#loginUserName')) {
      const userName =
        this.props.user && this.props.user.result && this.props.user.result.firstName
          ? this.props.user.result.firstName
          : null;
      const span = document.querySelector('#loginUserName');
      span.textContent = '¿No eres ' + userName + '?';
    }
  };

  redirectLogOut = () => {
    const logoutLink = document.querySelector('#logoutLink');
    if (logoutLink) {
      logoutLink.addEventListener('click', () => {
        this.handleLogOut();
      });
    }
  }

  // TODO: Don't work properly
  handleLogOut = () => {
    const { user, handleUserLogout: handleUserLogoutFn = () => {} } = this.props;
    const result = user?.result || {};
    const { emailId = '' } = result;
    const email = emailId;

    const userLogout = {};
    userLogout.login = email;

    if (email) {
      handleUserLogoutFn(userLogout).then((response) => {
        if (response.status.status === 'success' && window) {
          window.location.href = '/';
        }
      });
    }
  };

  loadFooter = ({ targeterContents } = []) => {
    if (Array.isArray(targeterContents) && targeterContents.length > 0) {
      return { __html: targeterContents[0].data };
    }
    return null;
  }

  // TODO: Don't work properly
  redirectToLoginPage = () => {
    if (document.querySelector('#signInFooter')) {
      document.querySelector('#signInFooter').addEventListener('click', () => {
        browserHistory.push(applicationRoutes.createAccount);
      });
    }
  };

  showUserName = () => {
    if (document.querySelector('#loginUserName')) {
      const { user = {} } = this.props;
      const result = user?.result || {};
      const { firstName = '' } = result;

      const span = document.querySelector('#loginUserName');
      span.textContent = '¿No eres ' + firstName + '?';
    }
  }

  componentDidMount = () => {
    this.redirectToLoginPage();
    this.showUserName();
  };

  render() {
    const { footer = {}, router = {} } = this.props;
    const { data = {} } = footer;
    const { result = {} } = data || {};
    const { targeterContents } = result;

    const { location = {}, params = '' } = router;
    const { pathname = '' } = location;

    let showFooter = true;

    // ? Rule bussines. In this urls don't show footer
    const routeDataWeb = [
      applicationRoutes.mesaType,
      applicationRoutes.openType,
      applicationRoutes.celebrationType,
      applicationRoutes.createFirst_communion,
      applicationRoutes.createConfirmations,
      applicationRoutes.createBar_Mitzvah,
      applicationRoutes.createMeetings,
      applicationRoutes.createChildrensParty,
      applicationRoutes.createAniversary,
      applicationRoutes.createBirthday,
      applicationRoutes.createFarewell,
      applicationRoutes.addDeliveryAddress,
      applicationRoutes.benefits,
      applicationRoutes.createAccount,
      applicationRoutes.partialTransference, // Account Transference and clouser
      applicationRoutes.closureTransference,
    ];

    const routeDataWAP = [
      applicationRoutes.mesaType,
      applicationRoutes.openType,
      applicationRoutes.celebrationType,
      applicationRoutes.createFirst_communion,
      applicationRoutes.createConfirmations,
      applicationRoutes.createBar_Mitzvah,
      applicationRoutes.createMeetings,
      applicationRoutes.createChildrensParty,
      applicationRoutes.createAniversary,
      applicationRoutes.createBirthday,
      applicationRoutes.createFarewell,
      applicationRoutes.addDeliveryAddress,
      applicationRoutes.benefits,
      applicationRoutes.createAccount,
      applicationRoutes.partialTransference, // Account Transference and clouser
      applicationRoutes.closureTransference,
      
      applicationRoutes.createWedding,
      applicationRoutes.createBaby,
      applicationRoutes.createXVYears,
      applicationRoutes.createBaptisms,
      applicationRoutes.createReligious,
      applicationRoutes.createOpenHouse,
      applicationRoutes.createOtras,
      applicationRoutes.createMascotas,
      applicationRoutes.createBirthday,
      applicationRoutes.addDeliveryAddress,
      // applicationRoutes.searchEvent,
      // applicationRoutes.giftTableList,
      // applicationRoutes.giftListGuestView
    ];

    const currentRoute = pathname;
    const routeProps = params;

    const routeData = channel === "web" ? routeDataWeb : routeDataWAP

    routeData.map((info) => {
      const exactRoute = commonUtil.getRouteByParameter(info, routeProps);
      if (exactRoute && exactRoute === currentRoute) {
        showFooter = false;
      }
      return showFooter;
    });

    if (showFooter) {
      return (
        <>
          {channel === 'wap' ? (
            <NewFooterComponentWap />
          ) : (
            <footer
              id='footer'
              ref={(myFooter) => (this.myFooter = myFooter)}
              className={channel === 'wap' ? 'footer' : ''}
              dangerouslySetInnerHTML={this.loadFooter({
                targeterContents,
                result,
              })}
            />
          )}
        </>
      );
    }
    return null;
  }
}
const mapStateToProps = state => ({
  footer: state.footer,
  user: state.user.data,
});

const matchDispatchToProps = dispatch => bindActionCreators({ handleUserLogout }, dispatch);

export default connect(mapStateToProps, matchDispatchToProps)(Footer);
